import { FC } from "react"
import { Box } from "@/ui-component/mui.components"
import { UText } from "@/ui-component/components"

const InputSummary: FC<{ title?: string; label: string; inputVal: string }> = ({
  title,
  label,
  inputVal,
}) => {
  const summaryStyle = {
    width: 316,
    ml: 1,
    lineHeight: "16px",
    color: "text.primary",
    whiteSpace: "break-spaces",
  }

  return (
    <>
      <Box
        className="summary-data-row"
        sx={{ py: 1, mb: "4px", display: "flex", flexDirection: "row", pl: 1, maxWidth: "560px", flexWrap: "wrap" }}
      >
        {title && <UText
          variant={"body2"}
          sxProp={{
            width: "100%",
            flexBasis: "100%",
            color: "rgba(0, 0, 0, 0.60)",
            pb: 1,
          }}
        >
          {title}
        </UText>}
        <UText
          variant={"body2"}
          sxProp={{
            width: "200px",
            color: "rgba(0, 0, 0, 0.60)",
          }}
        >
          {label}
        </UText>
        <Box sx={{flexGrow:1}}>
          {inputVal && (
            <>
              <UText
                component={"div"}
                variant={"subtitle2"}
                sxProp={{
                  ...summaryStyle,
                  //   fontWeight: schema.fontweight,
                  wordWrap: "break-word",
                }}
              >
                {inputVal}
              </UText>
            </>
          )}
        </Box>
      </Box>
    </>
  )
}

export default InputSummary
